import validate from '../../Validate/Validate';

export default interface IAutoRecovery {
	get(): Promise<IAutoRecoveryConfiguration>;
	set(configuration: IAutoRecoveryConfiguration): Promise<void>;
}

export type IAutoRecoveryConfiguration =
	| { enabled: false; autoEnableTimeoutMs?: number }
	| { enabled: true; healthcheckIntervalMs: number };

export const validateAutoRecoveryConfiguration = (configuration: IAutoRecoveryConfiguration) => {
	const validation = validate({ configuration }).setError(new Error('Invalid auto recovery configuration')).required();

	if (!configuration.enabled) {
		validation.object({ enabled: 'boolean', autoEnableTimeoutMs: '?number' });
	} else {
		validation.object({ enabled: 'boolean', healthcheckIntervalMs: 'number' });
	}
};
